import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {catchError, finalize, of, Subject, take, takeUntil} from 'rxjs';
import {EntidadeService} from 'src/app/api/module/erp/services/area-logada/entidade/entidade.service';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {TipoDeclinioPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-declinio-proposta-enum';
import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {FormatarUtil} from 'src/app/pages/area-logada/shared/pipes/utils/formatadores.util';
import {FormularioDadosBancariosPropostaComponent} from '../../../../shared/formulario-dados-bancarios-proposta/formulario-dados-bancarios-proposta.component';
import {ReducaoCarenciaPropostaComponent} from '../../../../shared/reducao-carencia-proposta/reducao-carencia-proposta.component';

@Component({
  selector: 'app-documentos-proposta-externa-unimedOdonto',
  templateUrl: './documentos-proposta-externa-unimedOdonto.component.html',
  styleUrls: ['./documentos-proposta-externa-unimedOdonto.component.scss'],
})
export class DocumentosPropostaExternaUnimedOdontoComponent implements OnInit {
  @Input() idProposta!: string;
  @Input() listaBeneficiarioDSSelecionados!: string[];
  @Input() heOdonto!: boolean;
  @Input() dadosOperadoraDM!: any;

  @ViewChild(ReducaoCarenciaPropostaComponent)
  _reducaoCarenciaPropostaComponent!: ReducaoCarenciaPropostaComponent;
  @ViewChild(FormularioDadosBancariosPropostaComponent)
  _formularioDadosBancariosPropostaComponent!: FormularioDadosBancariosPropostaComponent;

  readonly TipoPropostaEnum = TipoPropostaEnum;
  private destroy$ = new Subject<void>();
  tipoPropostaTitular!: TipoPropostaEnum;
  listaBeneficiariosFormulario: FormGroup[] = [];
  nomeTitular: string = '';
  cpfTitular: string = '';
  codigoProposta = '';
  entidadeProposta: string = '';
  razaoSocialEntidade: string = '';
  vigenciaProposta: string = '';
  tipoPlano: any = '';
  acomadacaoPlano: string = '';
  ansProduto: string = '';
  beneficiarios: any[] = [];
  beneficiariosNome: any[] = [];
  totalPlano!: number;
  totalPlanoComTaxa!: number;
  respostasTitular: any[] = [];
  respostasDependentes: any[] = [];
  dadosProstaCompletos: any;
  beneficiariosComDocumentos: any[] = [];
  mostrarQuadroDoisReducaoCarencia: boolean = false;
  listaBeneficiariosCarencias = new Array<any>();
  formularioReducaoCarencia!: FormGroup;
  horaAssinaturaReducaoCarencia: string = '';
  dataAssinaturaReducaoCarencia: string = '';
  assinaturasPorTipo: {[key: string]: {data: string; hora: string}} = {};
  dataAssinaturaOrientacaoPortabilidade: string = '';
  horaAssinaturaOrientacaoPortabilidade: string = '';
  horaAssinaturaOrientacaoSumula: string = '';
  dataAssinaturaDadosBancarios: string = '';
  horaAssinaturaDadosBancarios: string = '';
  dataAssinaturaCartaOrientacaoDS: string = '';
  horaAssinaturaCartaOrientacaoDS: string = '';
  dataAssinaturaDocFinal: string = '';
  horaAssinaturaDocFinal: string = '';
  tipoRegistroProduto: string = '';
  dataDeclinio: string = '';
  horaDeclinio: string = '';
  motivoDeclinio: string = '';
  tipoDeclinio!: TipoDeclinioPropostaEnum;
  tipoProduto!: TipoProduto_E_OperadoraEnum;
  caminhoLogoOdontoPlanos?: any;
  numeroCartao: string = '123456';
  tipoProdutoEnum = TipoProduto_E_OperadoraEnum;
  dataAssinatura: any;
  dataHoraAssinaturaAreaLogada: any = '';
  dataPreenchimentoProposta: any = '';
  fantasyName: any;
  dadosOperadoraCabecalho: any;
  operadoraVM: any;
  nomeCorretora: string = '';
  nomeVendedor: string = '';
  formEntidadeSomenteLeitura = true;
  existeFormularioEntidade: boolean = true;
  retornoDadosFormularioEntidade: any;
  valorRecebidoPeloBeneficiario: any;
  statusProposta: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private _activeRoute: ActivatedRoute,
    private _spinnerService: SpinnerService,
    private toastr: ToastrService,
    private _errorLoggingService: ErrorLoggingService,
    private _entidadeService: EntidadeService,
    private _propostaCotacaoService: PropostaCotacaoService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.operadoraVM = this.carregarDadosOperadora();
    await this.buscarDadosDocFinal();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  async buscarDadosDocFinal(): Promise<void> {
    this.iniciarSpinner();
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || this.idProposta;
    this._propostaCotacaoService
      .buscarDadosDocumentoFinal(propostaId, this.listaBeneficiarioDSSelecionados)
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        catchError(error => {
          this.toastr.error('Falha ao carregar documento com dados completos da proposta');
          this._errorLoggingService.logError('Buscar dados da proposta para o documento final', error, {
            contexto: 'Erro ao buscar dados da proposta para o documento final',
          });
          return of([]);
        }),
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe(data => {
        this.dadosOperadoraCabecalho = {
          nomeOperadora: data.operatorName,
          ansRegister: data.operatorAnsRegister,
          site: data.operatorSite,
          cnpjOperadora: data.operatorCNPJ,
          contatoOPeradora: data.operatorNumber,
          tipoProduto: data?.productType,
          logoOperadora: data?.operatorURLImage,
          ehInclusaoDependente: data?.dependentInclusion,
        };

        this.tipoProduto = data?.productType;
        this.dadosProstaCompletos = data && data;
        let propostaDeclinada = data.active;
        this.nomeCorretora = this.dadosProstaCompletos?.brokerDescription;
        this.nomeVendedor = this.dadosProstaCompletos?.brokerEmployeeDescription;
        this.valorRecebidoPeloBeneficiario = data.valueReceived;

        this.executarMetodosSequenciasComSeguranca(this.preencherDadosDaProposta);
        this.executarMetodosSequenciasComSeguranca(this.separarBeneficiarios, this.dadosProstaCompletos);
        this.executarMetodosSequenciasComSeguranca(this.preencherAssinaturas, this.dadosProstaCompletos.dealLeads);
        this.executarMetodosSequenciasComSeguranca(this.preencherDadosBancarios);
        this.buscarDadosPropostaEntidadeFormulario();
        if (!propostaDeclinada) {
          this.mostrarDeclinioProposta(this.dadosProstaCompletos);
        }
        this.montarBeneficiariosComDocumentos();
      });
  }

  private executarMetodosSequenciasComSeguranca(fn: Function, ...args: any[]) {
    try {
      fn.apply(this, args);
    } catch (e: any) {
      // this.toastr.info(`O metodo: ${fn.name} falhou`);
    }
  }

  criarFormGrupoBeneficiario(dados: any): FormGroup {
    return this.formBuilder.group({
      name: new FormControl(dados.name || ''),
      birthDate: new FormControl(FormatarUtil.data(dados.birthDate || '')),
      cpf: new FormControl(FormatarUtil.cpf(dados.cpf || null)),
      civilStatus: new FormControl(dados?.civilStatus?.name || ''),
      sex: new FormControl(FormatarUtil.sexo(dados.sex || '')),
      cns: new FormControl(FormatarUtil.cns(dados.cns || '')),
      mothersName: new FormControl(dados.mothersName || ''),
      adress: new FormControl(dados.addressData?.adress || ''),
      neighborhood: new FormControl(dados.addressData?.adressNeighborhood || ''),
      number: new FormControl(dados.addressData?.adressNumber || ''),
      state: new FormControl(dados.addressData?.city.state.uf || ''),
      city: new FormControl(dados.addressData?.city.name || ''),
      cep: new FormControl(FormatarUtil.cep(dados.addressData?.adressCep || '')),
      adressComplement: new FormControl(dados.addressData?.adressComplement || ''),
      previousOperator: new FormControl(dados.analysisPeriodReduction?.previousOperator || ''),
      dwellTime: new FormControl(dados.analysisPeriodReduction?.dwellTime || ''),
      mobilePhone: new FormControl(FormatarUtil.telefone(dados.mobilePhone || '')),
      homePhone: new FormControl(FormatarUtil.telefone(dados.homePhone || '')),
      businessPhone: new FormControl(FormatarUtil.telefone(dados.businessPhone || '')),
      email: new FormControl(dados.email || ''),
      branchCompanyContractKinship: new FormControl(dados?.branchCompanyContractKinship?.description || ''),
      // Campos que não recebem dados do Banco
      declaracaoNascidoVivo: new FormControl(dados.declaracaoNascidoVivo || ''),
      rg: new FormControl(dados.rg || ''),
      shipmentDate: new FormControl(dados.shipmentDate || ''),
      idIssuingBody: new FormControl(dados.idIssuingBody || ''),
      dataAdmissao: new FormControl(dados.dataAdmissao || ''),
      pis: new FormControl(dados.pis || ''),
      localAtendimento: new FormControl(dados.localAtendimento || ''),
    });
  }

  private separarBeneficiarios(dados: any) {
    const beneficiario = dados?.holderProposal;
    if (!beneficiario) return;

    const {dependentsProposal = [], ...titularData} = beneficiario;

    // Titular
    this.beneficiariosComDocumentos.push({
      nome: titularData.name,
      documentos: titularData.documentProposals || [],
    });

    // Dependentes
    dependentsProposal.forEach((dependente: any) => {
      this.beneficiariosComDocumentos.push({
        nome: dependente.name,
        documentos: dependente.documentProposals || [],
      });
    });
    this.adicionarBeneficiario({...titularData, isDependent: false});
    this.processarDependentes(dependentsProposal);
  }

  private adicionarBeneficiario(dados: any) {
    // Lista de objetos simples
    this.beneficiarios.push(dados);

    // Lista de FormGroups
    const formGroup = this.criarFormGrupoBeneficiario(dados);
    this.listaBeneficiariosFormulario.push(formGroup);
  }

  private processarDependentes(dependents: any[]) {
    if (!Array.isArray(dependents)) return;
    dependents.forEach(dependente => {
      this.adicionarBeneficiario({
        ...dependente,
        isDependent: true,
      });
    });
  }

  preencherDadosDaProposta() {
    this.entidadeProposta = this.dadosProstaCompletos.branchCompanyName;
    this.razaoSocialEntidade = this.dadosProstaCompletos.branchCompanySocialReason;
    this.codigoProposta = String(this.dadosProstaCompletos.code);
    this.vigenciaProposta = FormatarUtil.data(this.dadosProstaCompletos.effectiveDate);
    this.tipoPlano = this.dadosProstaCompletos.productName;
    this.acomadacaoPlano = this.dadosProstaCompletos.accommodationName;
    this.totalPlano = this.dadosProstaCompletos.totalPriceValue;
    this.totalPlanoComTaxa = this.dadosProstaCompletos.membershipFee;
    this.nomeTitular = this.dadosProstaCompletos.holderProposal.name;
    this.cpfTitular = FormatarUtil.cpf(this.dadosProstaCompletos.holderProposal.cpf);
    this.ansProduto = this.dadosProstaCompletos.registerNumber;
    this.tipoPropostaTitular = this.dadosProstaCompletos.proposalType;
    this.tipoRegistroProduto = this.dadosProstaCompletos.registerType;
  }

  preencherAssinaturas(dados: any) {
    let listaStepsAssinados = dados;
    let assinaturaDadosBancarios;

    const assinaturasDocFinal = listaStepsAssinados.find(
      (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_ENDERECO,
    );

    if (this.dadosOperadoraCabecalho.ehInclusaoDependente) {
      assinaturaDadosBancarios = listaStepsAssinados.find(
        (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_ENDERECO,
      );
    } else {
      assinaturaDadosBancarios = listaStepsAssinados.find(
        (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_BANCO,
      );
    }

    if (assinaturasDocFinal) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturasDocFinal.createDate);
      ((this.dataHoraAssinaturaAreaLogada = dataAssinatura.data + 'às'), dataAssinatura.hora);
      this.dataAssinaturaDocFinal = dataAssinatura.data;
      this.horaAssinaturaDocFinal = dataAssinatura.hora;
    }

    if (assinaturaDadosBancarios) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturaDadosBancarios.createDate);
      this.dataAssinaturaDadosBancarios = dataAssinatura.data;
      this.horaAssinaturaDadosBancarios = dataAssinatura.hora;
    }
  }

  preencherDadosBancarios() {
    const dadosBancarios = this.dadosProstaCompletos?.holderProposal?.bankDetails;
    if (dadosBancarios) {
      this._formularioDadosBancariosPropostaComponent.preencherDados(dadosBancarios);
    }
  }

  private montarBeneficiariosComDocumentos() {
    this.beneficiariosComDocumentos = [];

    const titular = this.dadosProstaCompletos?.holderProposal;
    if (titular) {
      const docsTitular: any[] = [];

      // Redução de carência
      if (titular.analysisPeriodReduction) {
        const reducao = titular.analysisPeriodReduction;
        if (reducao.ctp) {
          docsTitular.push({
            description: 'Carta de Tempo de Permanência',
            filePath: reducao.ctp,
          });
        }
        if (reducao.dapo) {
          docsTitular.push({
            description: 'Documento de Adimplância do Plano de Origem',
            filePath: reducao.dapo,
          });
        }
      }

      // Documentos normais
      if (Array.isArray(titular.documentProposals)) {
        docsTitular.push(...titular.documentProposals);
      }

      this.beneficiariosComDocumentos.push({
        nome: titular.name || 'Titular',
        documentos: docsTitular,
      });
    }

    const dependentes = this.dadosProstaCompletos?.holderProposal?.dependentsProposal || [];
    dependentes.forEach((dep: any, index: number) => {
      const docsDep: any[] = [];

      // Redução de carência
      if (dep.analysisPeriodReduction) {
        const reducao = dep.analysisPeriodReduction;
        if (reducao.ctp) {
          docsDep.push({
            description: 'Carta de Tempo de Permanência',
            filePath: reducao.ctp,
          });
        }
        if (reducao.dapo) {
          docsDep.push({
            description: 'Documento de Adimplância do Plano de Origem',
            filePath: reducao.dapo,
          });
        }
      }

      // Documentos normais
      if (Array.isArray(dep.documentProposals)) {
        docsDep.push(...dep.documentProposals);
      }

      this.beneficiariosComDocumentos.push({
        nome: dep.name || `Dependente ${index + 1}`,
        documentos: docsDep,
      });
    });
  }

  mostrarDeclinioProposta(dados: any) {
    const listaStepsAssinados = dados.dealLeads;
    const propostaDeclinada = listaStepsAssinados.find(
      (item: any) => item.step === PropostaExternaEnum.PROPOSTA_DECLINADA,
    ); //Proposta Declinada
    this.motivoDeclinio = dados.declineReason;
    this.statusProposta = !!propostaDeclinada;

    if (this.motivoDeclinio) {
      let dataFormatada = FormatarUtil.assinatura(propostaDeclinada.createDate);
      this.dataDeclinio = dataFormatada.data;
      this.horaDeclinio = dataFormatada.hora;
      this.tipoDeclinio = TipoDeclinioPropostaEnum.DECLINIO_MOTIVO;
    } else {
      let dataFormatada = FormatarUtil.assinatura(propostaDeclinada.createDate);
      this.dataDeclinio = dataFormatada.data;
      this.horaDeclinio = dataFormatada.hora;

      if (propostaDeclinada && this.tipoPropostaTitular == TipoPropostaEnum.PORTABILIDADE) {
        this.tipoDeclinio = TipoDeclinioPropostaEnum.DECLINIO_PORTABILIDADE;
      } else {
        this.tipoDeclinio = TipoDeclinioPropostaEnum.DECLINIO_25_DIAS;
      }
    }
  }

  isOdonto(): boolean {
    return TipoProduto_E_OperadoraComponent.isOdonto(this.tipoProduto);
  }

  carregarDadosOperadora(): string {
    const cnpjOperadoraFiltro =
      this.dadosOperadoraCabecalho?.cnpjOperadora || this.dadosOperadoraDM.operatorObject.cnpj;

    if (!cnpjOperadoraFiltro) {
      return '';
    }
    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    // Retorna o logo dos dados ou um padrão
    return dadosOperadora;
  }
  async buscarDadosPropostaEntidadeFormularioAdservip() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;
    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAdservip(this.idProposta)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.retornoDadosFormularioEntidade = data;
          }
        },
        error: error => {
          if (error.status == 404) {
            this.existeFormularioEntidade = false;
          }
          // this.toastr.info(error.message);
          this.pararSpinner();
        },
      });
  }

  async buscarDadosPropostaEntidadeFormularioAbje() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;
    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAbje(this.idProposta)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.retornoDadosFormularioEntidade = data;
          }
        },
        error: error => {
          if (error.status == 404) {
            this.existeFormularioEntidade = false;
          }
          // this.toastr.info(error.message);
          this.pararSpinner();
        },
      });
  }

  async buscarDadosPropostaEntidadeFormulario() {
    if (this.entidadeProposta === 'ADSERVIP') {
      this.buscarDadosPropostaEntidadeFormularioAdservip();
    } else if (this.entidadeProposta === 'ABJE') {
      this.buscarDadosPropostaEntidadeFormularioAbje();
    }
  }
}
